import React, { useMemo } from 'react';
import { Area, AreaChart, ResponsiveContainer, YAxis } from 'recharts';
import { TypedMemo } from '../../common/types';
import { useChartTokens } from '../../music24/theme/useChartTokens';
import styles from './SMLCardSparkline.module.scss';

interface SMLCardSparklineProps {
  /** One click count per day, oldest first. */
  values: number[];
}

/**
 * The click trend on a card. Smoothing is fine here, unlike the detail chart:
 * this shows shape at a glance and carries no axis to read a value against.
 */
const SMLCardSparklineComponent: React.FC<SMLCardSparklineProps> = ({ values }) => {
  const tokens = useChartTokens();
  const data = useMemo(() => values.map((value) => ({ value })), [values]);

  // `every` is true for an empty list too.
  if (values.every((value) => value === 0)) {
    return <span className={styles.flat} />;
  }

  return (
    <span className={styles.chart}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 2, right: 0, bottom: 0, left: 0 }}>
          <YAxis hide domain={[0, 'dataMax']} />
          <Area
            type="monotone"
            dataKey="value"
            stroke={tokens.brandLift}
            strokeWidth={1.5}
            fill={tokens.brandLift}
            fillOpacity={0.16}
            isAnimationActive={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </span>
  );
};

export const SMLCardSparkline = TypedMemo(SMLCardSparklineComponent);
